import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { SequencerByKey } from 'vscode/vscode/vs/base/common/async';
import { IEncryptionService } from 'vscode/vscode/vs/platform/encryption/common/encryptionService.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { BaseSecretStorageService } from '../../../../platform/secrets/common/secrets.js';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { IStorageService } from 'vscode/vscode/vs/platform/storage/common/storage.service';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService.service';

let BrowserSecretStorageService = class BrowserSecretStorageService extends BaseSecretStorageService {
    constructor(storageService, encryptionService, environmentService, logService) {
        super(true, storageService, encryptionService, logService);
        if (environmentService.options?.secretStorageProvider) {
            this._secretStorageProvider = environmentService.options.secretStorageProvider;
            this._embedderSequencer = ( new SequencerByKey());
        }
    }
    get(key) {
        if (this._secretStorageProvider) {
            return this._embedderSequencer.queue(key, () => this._secretStorageProvider.get(key));
        }
        return super.get(key);
    }
    set(key, value) {
        if (this._secretStorageProvider) {
            return this._embedderSequencer.queue(key, async () => {
                await this._secretStorageProvider.set(key, value);
                this.onDidChangeSecretEmitter.fire(key);
            });
        }
        return super.set(key, value);
    }
    delete(key) {
        if (this._secretStorageProvider) {
            return this._embedderSequencer.queue(key, async () => {
                await this._secretStorageProvider.delete(key);
                this.onDidChangeSecretEmitter.fire(key);
            });
        }
        return super.delete(key);
    }
    get type() {
        if (this._secretStorageProvider) {
            return this._secretStorageProvider.type;
        }
        return super.type;
    }
};
BrowserSecretStorageService = ( __decorate([
    ( __param(0, IStorageService)),
    ( __param(1, IEncryptionService)),
    ( __param(2, IBrowserWorkbenchEnvironmentService)),
    ( __param(3, ILogService))
], BrowserSecretStorageService));

export { BrowserSecretStorageService };
